import Header from "@appComponents/Header/Header";
import { Layout, Tabs } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import SecondaryMarket from "./tabs/SecondaryMarket";
import { RouteComponentProps, withRouter } from "react-router-dom";
import PrivateEquityMarket from "./tabs/PrivateEquityMarket";

type MarketsAppProps = {
  investorId?: number;
  userSignedIn: boolean;
};

const getTabs = ({ investorId, userSignedIn }: MarketsAppProps) => [
  {
    label: "Secondary Market",
    key: "1",
    children: (
      <SecondaryMarket investorId={investorId} userSignedIn={userSignedIn} />
    ),
  },
  {
    label: (
      <div className="flex items-center gap-2 text-grey-lightest">
        <span>Public Shares</span>
        <span className="uppercase rounded-full text-white bg-primary-regular font-semibold text-[11px] px-[8px] py-[3px]">
          Soon
        </span>
      </div>
    ),
    key: "2",
    disabled: true,
    children: <div>Public Shares (SOON)</div>,
  },
  {
    label: "Primary Market",
    key: "3",

    children: <PrivateEquityMarket />,
  },
];

const MarketsApp = ({
  investorId,
  userSignedIn,
  location,
  history,
}: RouteComponentProps & MarketsAppProps) => {
  const [activeKey, setActiveKey] = useState("1");

  const handleChangeTab = (key: string) => {
    setActiveKey(key);

    if (key === "1") {
      history.replace("/market/");
    } else if (key === "3") {
      history.replace("/search/pitches");
    }
  };

  const tabs = useMemo(
    () => getTabs({ investorId, userSignedIn }),
    [investorId, userSignedIn]
  );

  useEffect(() => {
    if (location.pathname.includes("/search/pitches")) {
      setActiveKey("3");
    }
  }, [location.pathname]);

  return (
    <div className="tailwind">
      <Header padding="140 20" />
      <div className="w-full py-8 max-w-[1140px] relative m-auto mt-[-280px] block">
        <div className="tailwind-layout">
          <Layout className="tailwind-layout">
            <Layout.Content>
              <Tabs
                centered
                activeKey={activeKey}
                onChange={handleChangeTab}
                items={tabs}
                className="tailwind-tabs"
              />
            </Layout.Content>
          </Layout>
        </div>
      </div>
    </div>
  );
};

export default withRouter(MarketsApp);
